<script lang="ts">
	import type { Component } from 'svelte';
	import SectionRenderer from './SectionRenderer.svelte';
	import ContentPageSearchResult from '../search/ContentPageSearchResult.svelte';
	import EventSearchResult from '../search/EventSearchResult.svelte';
	import GenreSearchResult from '../search/GenreSearchResult.svelte';
	import FestivalSearchResult from '@comp/search/FestivalSearchResult.svelte';

	let {
		blocks,
		caller
	}: {
		blocks: any[];
		caller?: string;
	} = $props();

	const sectionMap = new Map<string, Component<any>>();

	sectionMap.set('content_page', ContentPageSearchResult);
	sectionMap.set('event', EventSearchResult);
	sectionMap.set('genre', GenreSearchResult);
	sectionMap.set('festival_page', FestivalSearchResult);
</script>

<SectionRenderer
	showErrors={false}
	sections={blocks}
	caller={caller || 'SearchSections'}
	{sectionMap}
/>
